var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ADMIN_SIGNIN_RES)?_c('div',[_c('cSysDashboard')],1):_vm._e(),(_vm.GET_SIGNIN_RES)?_c('div',[_c('cAgentDashboard')],1):_vm._e(),(_vm.isLoading)?_c('CElementCover',{attrs:{"opacity":0.8}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }